import { createFileRoute } from '@tanstack/react-router'
import { DocumentDeletePage } from '@/features/documents/delete'

export const Route = createFileRoute('/documents_/$documentId/delete')({
  component: DocumentDeletePage,
})
